if (typeof complementaryProductsComponent === 'undefined')
{   
    class ComplementaryProductsComponent extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            const url = this.dataset.url;

            this.buildProducts(url);    
        }

        buildProducts(url) {
            const fetchProducts = async (url) => {
                const res = await fetch(url);
                let text = await res.text();
                    
                const html = document.createElement('div');
                text = text.replaceAll('variant-selects', 'div').replaceAll('variant-radios', 'div').replaceAll('product-tab', 'div').replaceAll('compare-color', 'div').replaceAll('breadcrumb-component', 'div');
                html.innerHTML = text;
                
                const recommendations = html.querySelector('[data-complementary-product]');
                const numbersArray = Array.from(document.querySelectorAll('[data-gtm-category="productClick"]')).map(element => {
                        return Number(element.dataset.gtmId); 
                    });
                    let index = Math.max(...numbersArray)+1;
                recommendations.querySelectorAll('.product').forEach(item => {
                    item.querySelectorAll('a').forEach(link => {
                        link.setAttribute('data-gtm-id', index)
                    })
                    index++;
                })
                if (recommendations && recommendations.innerHTML.trim().length) {
                    this.innerHTML = recommendations.innerHTML;
    
                    if (window.sharedFunctions.checkNeedToConvertCurrency()) {
                        Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
                    }
                }
                    setTimeout(function(){
                        const products = recommendations.querySelectorAll('.card-product');
                        if (!productMap) {
                            productMap = {}

                            products.forEach(product => {
                                productMap[Object.keys(productMap).length + 1] = {
                                    brand: `hyperx`,
                                    pl: 'MS',
                                    cat: 'accessories',
                                    subCat: product.dataset.gtmSubCat,
                                    formFactor: product.dataset.gtmSubCat,
                                    id: product.dataset.gtmId,
                                    list: `pairs-with`,
                                    name: product.dataset.gtmName,
                                    position: Object.keys(productMap).length + 1,
                                    price: product.dataset.gtmPrice,
                                    variant:  product.dataset.gtmVariant,
                                    xsellMethod: ``,
                                    xsellProdInfo: ``
                                }
                            })
                        } else {
                            products.forEach(product => {
                                productMap[Object.keys(productMap).length + 1] = {
                                    brand: `hyperx`,
                                    pl: 'MS',
                                    cat: 'accessories',
                                    subCat: product.dataset.gtmSubCat,
                                    formFactor: product.dataset.gtmSubCat,
                                    id: product.dataset.gtmId,
                                    list: `pairs-with`,
                                    name: product.dataset.gtmName,
                                    position: Object.keys(productMap).length + 1,
                                    price: product.dataset.gtmPrice,
                                    variant:  product.dataset.gtmVariant,
                                    xsellMethod: ``,
                                    xsellProdInfo: ``
                                }
                            })
                        }
                        document.addEventListener('DOMContentLoaded', () => {
                            dataLayer.push({
                                event: 'standards.productsReady',
                            });
                        });
                    }, 3500)
                    
                const productCarousel = this.querySelector('.products-carousel');
                this.initializeSlider(productCarousel);
            }
    
            fetchProducts(url);
        }
        
        initializeSlider(productCarousel = null) {
            if (productCarousel) {
                const itemArrows = productCarousel.dataset.itemArrows === 'true';
                const itemDots = productCarousel.dataset.itemDots === 'true';
                const itemRows = parseInt(productCarousel.dataset.itemRows);
                const itemToShow = parseInt(productCarousel.dataset.itemToShow);
                const complementaryStyle = this.classList.contains('style-1') ? true : false;

                $(productCarousel).on('init', () => {
                    this.calculateCard06Padding();
                });

                if(!productCarousel.classList.contains('slick-slider')) {
                    $(productCarousel).slick({
                        dots: itemDots,
                        arrows: itemArrows,
                        slidesToShow: complementaryStyle ? itemToShow : 1,
                        rows: !complementaryStyle ? itemRows : 1,
                        slidesToScroll: 1,
                        slidesPerRow: 1,
                        infinite: true,
                        rtl: window.rtl_slick,
                        nextArrow: window.arrows.icon_next,
                        prevArrow: window.arrows.icon_prev,
                        responsive: [
                            {
                                breakpoint: 1025,
                                settings: {
                                    get slidesToShow() {
                                        if (complementaryStyle) {
                                            slidesToShow: 2
                                        }
                                        if (!complementaryStyle) {
                                            slidesToShow: 1
                                        }
                                    }
                                }
                            },
                            {
                                breakpoint: 992,
                                settings: {
                                    get slidesToShow() {
                                        if (complementaryStyle) {
                                            slidesToShow: 2
                                        }
                                        if (!complementaryStyle) {
                                            slidesToShow: 1
                                        }
                                    }
                                }
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    get slidesToShow() {
                                        if (complementaryStyle) {
                                            slidesToShow: 2
                                        }
                                        if (!complementaryStyle) {
                                            slidesToShow: 1
                                        }
                                    }
                                }
                            },
                            {
                                breakpoint: 321,
                                settings: {
                                    slidesToShow: 1
                                }
                            }
                        ]
                    });
                }
            }
        }
        
        calculateCard06Padding() {
            if (!document.body.classList.contains('product-card-layout-06')) return;

            const selectOptionsHeight = this.querySelector('.product .card-action').scrollHeight;
            this.querySelector('.slick-list').style.paddingBottom = selectOptionsHeight + 'px';
        }
    }
    
    window.addEventListener('load', () => {
        customElements.define('complementary-products', ComplementaryProductsComponent);
    })

    var complementaryProductsComponent = ComplementaryProductsComponent;
}